// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"12d401b9","610":"b5ec101d"}[chunkId] + ".chunk.js";
};